export const edproCardOpen = function() {
    $(".js-rate").on("click", function(event) {
        $(this).parent().parent().toggleClass('open');
    });
}
